"use client";
import TalkToExperts from "../homepage/TalkToExperts";
import { useAuth } from "@/hook/useAuth";
import { useEffect, useState } from "react";

const BookSlot = () => {
  // CHECK IF USER IS LOGGED IN OR NOT
  const { isAnonymous } = useAuth();
  const [expertForm, setExpertForm] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const expertFromHandler = () => {
    setExpertForm(true);
    document.body.classList.add("overflow-hidden");
  };

  useEffect(() => {
    setCurrentStep(isAnonymous ? 1 : 2);
  }, [expertForm, isAnonymous]);

  return (
    <>
      <div className="container mx-auto py-[96px] px-5 lg:px-[96px] max-w-[1440px]">
        <div className="mx-auto  max-w-[1180px] rounded-[18px] sm:rounded-[24px] overflow-hidden bg-gradient-to-r from-[#0B0A2B] via-[#241c66] to-[#5B3DF0] px-6 py-11 sm:px-[5vw] lg:px-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 text-white text-left">
          <div>
            <h3 className="ff_poppins text-white text-[20px] sm:text-[2.6vw] lg:text-[28px] font-bold max-w-[520px] leading-tight">
              Confused which university actually fits your profile?
            </h3>
            <p className="text-[#C8C4EE] text-[14.5px] mt-1.5">
              Talk to a real mentor — free 15 minute call, no obligation.
            </p>
          </div>
          <button
            onClick={expertFromHandler}
            className="inline-flex items-center justify-center gap-2 px-[22px] py-[12px] rounded-full font-semibold text-[14.5px] border-none whitespace-nowrap transition-all duration-150 bg-white text-[#0B0A2B] hover:scale-105 shadow-[0_8px_20px_rgba(255,255,255,0.1)]"
          >
            Book 1:1 Session
          </button>
        </div>
      </div>
      {expertForm && (
        <TalkToExperts
          expertForm={expertForm}
          setExpertForm={setExpertForm}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      )}
    </>
  );
};
export default BookSlot;
